import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { Grid } from 'react-styled-flexboxgrid';

const ResponsiveGrid = styled(Grid).attrs({
  fluid: true,
})`
  ${breakpoint('lg')`
    padding-right: 4rem;
    padding-left: 4rem;
  `}
  ${breakpoint('md', 'lg')`
    padding-right: 2.5rem;
    padding-left: 2.5rem;
  `}
  ${breakpoint('sm', 'md')`
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  `}
  ${breakpoint('xs', 'sm')`
    padding-right: 1rem;
    padding-left: 1rem;
  `}
`;

export default ResponsiveGrid;
